import React from 'react';

/**
 * Reusable Loading Spinner Component with customizable size and message
 */
const LoadingSpinner = ({ 
    size = 'medium', 
    message = 'Loading...', 
    subMessage = '',
    fullScreen = false 
}) => {
    const sizes = {
        small: { spinner: 30, border: 4 },
        medium: { spinner: 50, border: 5 },
        large: { spinner: 70, border: 6 }
    };

    const { spinner, border } = sizes[size] || sizes.medium;

    const containerStyle = fullScreen ? styles.fullScreenContainer : styles.inlineContainer;

    return (
        <div style={containerStyle}>
            <div style={{ ...styles.spinner, width: spinner, height: spinner, borderWidth: border }}>
                <div style={styles.spinnerInner}></div>
            </div>
            {message && <p style={styles.message}>{message}</p>}
            {subMessage && <p style={styles.subMessage}>{subMessage}</p>}
        </div>
    );
};

const styles = {
    fullScreenContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '40px'
    },
    inlineContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
    },
    spinner: {
        border: '5px solid #f3f3f3',
        borderTop: '5px solid #27b05b',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '20px'
    },
    spinnerInner: {
        width: '100%',
        height: '100%'
    },
    message: {
        fontSize: '1.1rem',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '8px',
        textAlign: 'center'
    },
    subMessage: {
        fontSize: '0.9rem',
        color: '#64748b',
        textAlign: 'center',
        maxWidth: '400px'
    }
};

// Add keyframe animation via a dedicated style element
const styleEl = document.createElement('style');
styleEl.textContent = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
document.head.appendChild(styleEl);

export default LoadingSpinner;
